import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Profile } from 'src/app/assabil-kernel/models/entities/master-data/profile-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'profile-lov',
    templateUrl: './profile-lov.component.html',
    styleUrls: ['./profile-lov.component.scss']
})

export class ProfileLovComponent extends GenericLovComponent {
  
  code   : string;
  name   : string;
 

profiles            : Profile[] = [];
    columns = [
    {  prop: 'profileCode',  name: 'Code'},
    {  prop: 'name',         name: 'Name' 
    }
]

constructor(
    public dialogRef: MatDialogRef<ProfileLovComponent>,
    protected controlTablesService  : ControlTablesService,
    protected toastr                : ToastrService,
    protected router                : Router,
    protected location              : Location) {
    super();
    }
      
   
loadData() {
    this.controlTablesService.profilesGet(this.code, this.name).then(result => {
        this.profiles = result;
    }).catch(error => {
        this.toastr.error(error);
    })
}


//----------------------------------------------------------------------
closeModal(row : Profile){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
